export default function MinerIcon() {
  return (
    <svg version="1.1" width="37" height="37" viewBox="0 -70 700 700" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          d="m367.5 61.25h-35l-17.5 70h-17.5v52.5h105v-52.5h-17.5zm8.75 105h-52.5c-4.832 0-8.75-3.918-8.75-8.75s3.918-8.75 8.75-8.75h52.5c4.832 0 8.75 3.918 8.75 8.75s-3.918 8.75-8.75 8.75z"
          fill="currentColor"
        />
        <path d="m420 133.88v47.25l157.5-23.625z" fill="currentColor" />
        <path d="m280 181.12v-47.25l-157.5 23.625z" fill="currentColor" />
        <path
          d="m315 463.75c0 12.504 6.6719 24.059 17.5 30.312 10.828 6.25 24.172 6.25 35 0 10.828-6.2539 17.5-17.809 17.5-30.312v-262.5h-70zm26.25-240.62c0-4.832 3.918-8.75 8.75-8.75s8.75 3.918 8.75 8.75v140c0 4.832-3.918 8.75-8.75 8.75s-8.75-3.918-8.75-8.75zm0 183.75c0-4.832 3.918-8.75 8.75-8.75s8.75 3.918 8.75 8.75v35c0 4.832-3.918 8.75-8.75 8.75s-8.75-3.918-8.75-8.75z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}